import React, { forwardRef, Ref } from "react";
import { Date_toDateTimeString } from "../../common/dateUtils";

type DateTimeInputProps = {
    defaultValue: Date;
    onBlur: (dateString: string) => void;
    id: string;
    label: string | undefined;
    readOnly: boolean;
    className?: string;
    errorMessage?: string;
    minValue?: Date;
    maxValue?: Date;
};

const DateTimeInput = forwardRef<HTMLInputElement, DateTimeInputProps>(
    (
        { defaultValue, onBlur, id, label, readOnly: readonly = false, className = "", errorMessage = "", minValue, maxValue },
        ref
    ) => {
        return (
            <div className={`form-group ${className}`}>
                <label className="fw-bold form-label" htmlFor={id}>
                    {label}
                </label>
                <input
                    id={id}
                    className={`form-control ${readonly ? "read-only-input" : ""}`}
                    type="datetime-local"
                    defaultValue={Date_toDateTimeString(defaultValue)}
                    ref={ref}
                    readOnly={readonly}
                    onBlur={(e) => onBlur(e.target.value)}
                    min={minValue ? Date_toDateTimeString(minValue) : undefined}
                    max={maxValue ? Date_toDateTimeString(maxValue) : undefined}
                />
                <span className="text-danger">{errorMessage}</span>
            </div>
        );
    }
);

export default DateTimeInput;
